import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { translations, LANGUAGES } from "./translations";
import { extra } from "./extra";
import { extra2 } from "./extra2";
import { extra3 } from "./extra3";
import { extra4 } from "./extra4";
import { extra5 } from "./extra5";
import { extra6 } from "./extra6";
import { extra7 } from "./extra7";
import { extra8 } from "./extra8";
import { extra9 } from "./extra9";
import { extra10 } from "./extra10";
import { extra11 } from "./extra11";
import { extra12 } from "./extra12";
import { extra13 } from "./extra13";
import { extra14 } from "./extra14";
import { extra15 } from "./extra15";
import { extra16 } from "./extra16";
import { ptPT } from "./ptPT";

const LanguageContext = createContext(null);
const SUPPORTED = LANGUAGES.map((l) => l.code);

function detectInitial() {
  const saved = localStorage.getItem("mc_lang");
  if (saved && SUPPORTED.includes(saved)) return saved;
  const full = (navigator.language || "pt").toLowerCase();
  if (full === "pt-pt") return "pt-PT";
  const nav = full.slice(0, 2);
  return SUPPORTED.includes(nav) ? nav : "pt";
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(detectInitial);

  useEffect(() => {
    localStorage.setItem("mc_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = useCallback((l) => {
    if (SUPPORTED.includes(l)) setLangState(l);
  }, []);

  const t = useCallback(
    (key, vars) => {
      const dict = { ...(translations.pt || {}), ...(extra.pt || {}), ...(extra2.pt || {}), ...(extra3.pt || {}), ...(extra4.pt || {}), ...(extra5.pt || {}), ...(extra6.pt || {}), ...(extra7.pt || {}), ...(extra8.pt || {}), ...(extra9.pt || {}), ...(extra10.pt || {}), ...(extra11.pt || {}), ...(extra12.pt || {}), ...(extra13.pt || {}), ...(extra14.pt || {}), ...(extra15.pt || {}), ...(extra16.pt || {}), ...(lang === "pt-PT" ? ptPT : { ...(translations[lang] || {}), ...(extra[lang] || {}), ...(extra2[lang] || {}), ...(extra3[lang] || {}), ...(extra4[lang] || {}), ...(extra5[lang] || {}), ...(extra6[lang] || {}), ...(extra7[lang] || {}), ...(extra8[lang] || {}), ...(extra9[lang] || {}), ...(extra10[lang] || {}), ...(extra11[lang] || {}), ...(extra12[lang] || {}), ...(extra13[lang] || {}), ...(extra14[lang] || {}), ...(extra15[lang] || {}), ...(extra16[lang] || {}) }) };
      let str = dict[key] ?? key;
      if (vars && typeof str === "string") {
        Object.entries(vars).forEach(([k, v]) => {
          str = str.replace(new RegExp(`\\{${k}\\}`, "g"), String(v));
        });
      }
      return str;
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useI18n must be used within LanguageProvider");
  return ctx;
}
